import React, { useEffect, useState } from "react";
import axios from "axios";
import "../CSS/KelolaFAQs.css";

function KelolaFAQs() {
  const [faqs, setFaqs] = useState([]);

  const [formData, setFormData] = useState({
    pertanyaan: "",
    jawaban: "",
    role_target: "UMUM",
  });

  const [editId, setEditId] = useState(null);

  const API_URL = "https://api-tibismart.tifpsdku.com/api/faq";

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const res = await axios.get(`${API_URL}/`);
      setFaqs(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const resetForm = () => {
    setEditId(null);

    setFormData({
      pertanyaan: "",
      jawaban: "",
      role_target: "UMUM",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editId) {
        await axios.put(
          `${API_URL}/${editId}`,
          formData
        );

        alert("FAQ berhasil diperbarui");
      } else {
        await axios.post(
          `${API_URL}/add`,
          formData
        );

        alert("FAQ berhasil ditambahkan");
      }

      resetForm();
      fetchFaqs();
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };

  const handleEdit = (faq) => {
    setEditId(faq.id_faq);

    setFormData({
      pertanyaan: faq.pertanyaan,
      jawaban: faq.jawaban,
      role_target: faq.role_target,
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Hapus FAQ ini?")) return;

    try {
      await axios.delete(
        `${API_URL}/${id}`
      );

      fetchFaqs();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="faq-container">

      <div className="faq-header">
        
      </div>

      <div className="faq-stats">
        <div className="faq-card">
          <h3>{faqs.length}</h3>
          <span>Total FAQ</span>
        </div>
      </div>

      <div className="faq-form-card">

        <h3>
          {editId
            ? "Edit FAQ"
            : "Tambah FAQ"}
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Pertanyaan</label>

            <input
              type="text"
              name="pertanyaan"
              value={formData.pertanyaan}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Jawaban</label>

            <textarea
              rows="5"
              name="jawaban"
              value={formData.jawaban}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Role Target</label>

            <select
              name="role_target"
              value={formData.role_target}
              onChange={handleChange}
            >
              <option value="UMUM">
                UMUM
              </option>

              <option value="TENAGA_KESEHATAN">
                TENAGA KESEHATAN
              </option>

              <option value="DOKTER_PARU">
                DOKTER PARU
              </option>
            </select>
          </div>

          <div className="button-group">

            <button
              type="submit"
              className="save-btn"
            >
              {editId
                ? "Update FAQ"
                : "Tambah FAQ"}
            </button>

            {editId && (
              <button
                type="button"
                className="cancel-btn"
                onClick={resetForm}
              >
                Batal
              </button>
            )}

          </div>
        </form>
      </div>

      <div className="faq-table-card">
        <h3>Daftar FAQ</h3>

        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Pertanyaan</th>
              <th>Role</th>
              <th>Aksi</th>
            </tr>
          </thead>

          <tbody>

            {faqs.map((faq) => (
              <tr key={faq.id_faq}>
                <td>{faq.id_faq}</td>

                <td>
                  {faq.pertanyaan}
                </td>

                <td>
                  <span
                    className={`role-badge ${faq.role_target}`}
                  >
                    {faq.role_target}
                  </span>
                </td>

                <td>
                  <button
                    className="edit-btn"
                    onClick={() =>
                      handleEdit(faq)
                    }
                  >
                    Edit
                  </button>

                  <button
                    className="delete-btn"
                    onClick={() =>
                      handleDelete(
                        faq.id_faq
                      )
                    }
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))}

          </tbody>
        </table>
      </div>

    </div>
  );
}

export default KelolaFAQs;